<template>
    <div :style="{display: (this.inline) ? 'inline' : 'block'}">

        <span v-show="!fileSelected">

            <input ref="FileInput" :accept="accept" :multiple="false" style="display: none;" type="file"
                   @change="filesChanged($event)">
            <Button :label="label" class="p-button-outlined"
                    @click="$refs.FileInput.click()"/>

        </span>


        <span v-show="fileSelected">

            <Button :icon="icon" :label="fileSelected?.name+ ' (' + bytesToHumanPresent(fileSelected?.size) + ')'"
                    class="p-button-text"
                    icon-pos="left" @click="$emit('fileClick', fileSelected)"/>

            <Button class="p-button-text" icon="pi pi-times" @click="removeFile()"/>

        </span>


    </div>
</template>

<script>

import DataFilters from "../../utils/DataFilters";

export default {

    name: "FileInput",
    mixins: [DataFilters],
    props: {
        modelValue: null,
        label: {
            type: String,
            default: 'Выбрать файл',
        },
        accept: {
            type: String,
            default: '',
        },
        icon: {
            default: 'pi pi-eye',
            type: String
        },
        inline: {
            default: false,
            type: Boolean
        }

    },

    emits: ['fileChange', 'value', 'update:modelValue', 'fileClick'],
    data() {
        return {

            fileSelected: this.modelValue,

        }
    },
    methods: {

        filesChanged($event) {
            this.fileSelected = $event.target.files[0];
            this.$emit('update:modelValue', this.fileSelected);
            this.$emit('fileChange', this.fileSelected, this);
        },

        removeFile() {

            this.fileSelected = null;
            this.$refs.FileInput.value = null;
            this.$emit('update:modelValue', this.fileSelected);
            this.$emit('fileChange', this.fileSelected, this);

        }

    },
    watch: {

        modelValue: {
            immediate: true,
            handler(newVal, OldVal) {
                this.fileSelected = newVal
            }
        }

    },

}
</script>

<style scoped>

</style>